import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISchedule } from '../types/ISchedule';
import { Request } from './Request';

export interface IGetSchedulesResult extends IGetItemsResult {
  schedules: ISchedule[];
}

export class GetSchedulesRequest extends Request<IGetItemsParams, IGetSchedulesResult> {
  constructor(params: IGetItemsParams) {
    super('getSchedules', params);
  }
}
